module.exports = __webpack_public_path__ + "static/media/Sardor-Botirov-resume.e442ab2c.pdf";